import React, { useRef, useState, useEffect } from "react";
import { Table, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect from "components/Common/custom-select";
import { FiSave } from "react-icons/fi";
import ava1 from "../../../assets/images/brands/avatar1.png";
import ava2 from "../../../assets/images/brands/avatar2.png";
import ava3 from "../../../assets/images/brands/avatar3.png";
import ava4 from "../../../assets/images/brands/avatar4.png";
import { useDispatch, useSelector } from "react-redux";
import {
  createEmployee,
  fetchEmployeeTabWiseInfo,
} from "store/actions";
import moment from "moment";
import { parse, isValid } from "date-fns";
import CustomDatePicker from "common/CustomDatePicker";

const maritalStatusOptions = [
  { value: "1", label: "Un Married" },
  { value: "2", label: "Married" },
];

const childRelationOptions = [
  { value: "6", label: "Son" },
  { value: "7", label: "Daughter" },
  { value: "8", label: "Grandfather" },
  { value: "9", label: "Grandmother" },
];

const EmployeeFamily = ({ empID, onChange, formikRef, dropdownData, authDetails, isActive, onSuccess }) => {
  const dispatch = useDispatch();
  const { relation } = dropdownData;
  const {
    employeeFamilyInfo = [],
    success,
    loading,
    error,
  } = useSelector((state) => ({
    employeeFamilyInfo: empID == 0 ? [] : state.EmployeeDetailsReducer?.employeeTabData?.family || [],

    loading: state.employeeReducer?.loading,
    error: state.employeeReducer?.error,
    success: state.EmployeeDetailsReducer?.success
  }));
  // const [photoPreview, setPhotoPreview] = useState(null);
  // const [photoPreviewMother, setPhotoPreviewMother] = useState(null);
  // const [photoPreviewGuardian, setPhotoPreviewGuardian] = useState(null);
  const [previews, setPreviews] = useState({
    fatherPhoto: null,
    motherPhoto: null,
    guardianPhoto: null,
    spousePhoto: null,
  });
  const [rows, setRows] = useState([
    { id: 1, emp_id: empID, relation_id: "", child_name: "", child_dob: null, RelationType: "5" }
  ]);
  // const [isGuardian, setIsGuardian] = useState(false);
  const isInitialized = useRef(false);
  const alphaNumSpecial40Regex = /^[A-Za-z0-9\s.,\-/#()]+$/;

  useEffect(() => {
    if (employeeFamilyInfo && Object.keys(employeeFamilyInfo).length > 0) {
      const {
        emp_fathers = [],
        emp_mothers = [],
        emp_guardians = [],
        emp_marraiagestatus = [],
        emp_childrens = []
      } = employeeFamilyInfo;

      const parseDate = (dateStr) => {
        if (!dateStr) return null;
        let parsedDate = parse(dateStr, "dd-MM-yyyy", new Date());
        return isValid(parsedDate) ? parsedDate : null;
      };

      const father = emp_fathers[0] || {};
      const mother = emp_mothers[0] || {};
      const guardian = emp_guardians[0] || {};
      const marital = emp_marraiagestatus[0] || {};
      const children = emp_childrens || [];

      const getImagePath = (path) => path ? `${process.env.REACT_APP_IMAGE_BASE_URL}${path}` : null;

      formik.setValues((prevValues) => ({
        ...prevValues,
        fatherFullName: father.father_name || '',
        fatherDOB: parseDate(father.fat_dob),
        // fatherPhoto: getImagePath(father.fat_path),  // Fix image path

        motherFullName: mother.mother_name || '',
        motherDOB: parseDate(mother.mot_dob),
        // motherPhoto: getImagePath(mother.mot_path),

        guardianFullName: guardian.guardian_name || '',
        guardianDOB: parseDate(guardian.guard_dob),
        // guardianPhoto: getImagePath(guardian.guar_path),

        maritalStatus: maritalStatusOptions.find(
          (option) => option.value === String(marital?.maritial_status)
        ) || null,
        spouseName: marital.spouse_name || '',
        spouseDOB: parseDate(marital.spouse_dob),
        weddingDate: parseDate(marital.wed_date),
        // spousePhoto: getImagePath(marital.spouse_path),

        isGuardian: Boolean(guardian.guardian_name),
      }));

      // Update Preview State
      setPreviews({
        fatherPhoto: getImagePath(father.fat_path),
        motherPhoto: getImagePath(mother.mot_path),
        guardianPhoto: getImagePath(guardian.guar_path),
        spousePhoto: getImagePath(marital.spouse_path),
      });

      setRows(children.map((child, index) => ({
        id: index + 1,
        emp_id: empID,
        relation_id: child.relation_id || "",
        child_name: child.child_name || "",
        child_dob: parseDate(child.child_dob),
        RelationType: child.relation_type || "5"
      })));

      isInitialized.current = true;
    }
  }, [employeeFamilyInfo, isActive]);



  // const handleCheckboxChange = () => {
  //   setIsGuardian(!isGuardian);
  // };

  const transformPayload = (values, emp_id) => {
    return {
      fat: [{
        emp_id,
        father_name: values.fatherFullName,
        fat_dob: values.fatherDOB,
        fat_photo: "",
        RelationType: "1"
      }],
      mot: [{
        emp_id,
        mother_name: values.motherFullName,
        mot_dob: values.motherDOB,
        mot_photo: "",
        RelationType: "2"
      }],
      guar: values.isGuardian ? [{
        emp_id,
        guardian_name: values.guardianFullName,
        guard_dob: values.guardianDOB,
        guar_photo: "",
        RelationType: "3"
      }] : [],
      mar: values.maritalStatus?.value === "1"
        ? [{
          emp_id,
          maritial_status: values.maritalStatus.value,
          spouse_name: "",
          spouse_dob: "",
          wed_date: "",
          RelationType: "4"
        }]
        : values.maritalStatus?.value === "2"
          ? [{
            emp_id,
            maritial_status: values.maritalStatus.value,
            spouse_name: values.spouseName,
            spouse_dob: values.spouseDOB,
            wed_date: values.weddingDate,
            RelationType: "4"
          }]
          : [],
      chi: rows
    };
  };

  const SUPPORTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

  const photoValidation = (fieldName) =>
    Yup.mixed()
      .nullable()
      .test(
        `${fieldName}-fileType`,
        "Only JPG, JPEG, and PNG formats are allowed.",
        (value) => {
          if (!value) return true; // If no file, pass validation
          return SUPPORTED_FORMATS.includes(value.type);
        }
      )
      .test(
        `${fieldName}-fileSize`,
        "File size must be less than 2MB.",
        (value) => {
          if (!value) return true; // If no file, pass validation
          return value.size <= MAX_FILE_SIZE;
        }
      );

  const formik = useFormik({
    initialValues: {
      fatherFullName: '',
      fatherDOB: "",
      motherFullName: '',
      motherDOB: null,
      guardianFullName: '',
      guardianDOB: null,
      maritalStatus: null,
      spouseName: '',
      spouseDOB: null,
      weddingDate: null,
      rows: [],
      isGuardian: false,
      fatherPhoto: null,
      motherPhoto: null,
      guardianPhoto: null,
      spousePhoto: null,
    },
    validationSchema: Yup.object({
      fatherFullName: Yup.string()
        .required("Father name is required")
        .max(40, "Max length is 40")
        .matches(
          alphaNumSpecial40Regex,
          "Only alphabets, numerics and special characters allowed"
        ),

      motherFullName: Yup.string()
        .required("Mother name is required")
        .max(40, "Max length is 40")
        .matches(
          alphaNumSpecial40Regex,
          "Only alphabets, numerics and special characters allowed"
        ),

      guardianFullName: Yup.string()
        .max(40, "Max length is 40")
        .matches(
          alphaNumSpecial40Regex,
          "Only alphabets, numerics and special characters allowed"
        )
        .when("isGuardian", {
          is: true,
          then: (schema) => schema.required("Guardian name is required"),
          otherwise: (schema) => schema.nullable(),
        }),

      spouseName: Yup.string()
        .max(40, "Max length is 40")
        .matches(
          alphaNumSpecial40Regex,
          "Only alphabets, numerics and special characters allowed"
        )
        .when("maritalStatus", {
          is: (status) => status?.value === "2", // Married
          then: (schema) => schema.required("Spouse name is required"),
          otherwise: (schema) => schema.nullable(),
        }),
      maritalStatus: Yup.object().nullable().required('Marital status is required'),
      fatherPhoto: photoValidation("fatherPhoto"),
      motherPhoto: photoValidation("motherPhoto"),
      guardianPhoto: photoValidation("guardianPhoto"),
      spousePhoto: photoValidation("spousePhoto"),
      // spouseName: Yup.string().when('maritalStatus', {
      //   is: (status) => status?.value === 'married',  // Check if married
      //   then: Yup.string().required('Spouse name is required'),
      //   otherwise: Yup.string().notRequired()  // Not required if not married
      // }),    
      // spouseDOB: Yup.date().nullable().when('maritalStatus', {
      //   is: (status) => status?.value === 'married',
      //   then: Yup.date().required('Spouse date of birth is required').nullable(),
      //   otherwise: Yup.date().notRequired(),
      // }),
      // weddingDate: Yup.date().nullable().when('maritalStatus', {
      //   is: (status) => status?.value === 'married',
      //   then: Yup.date().required('Wedding date is required').nullable(),
      //   otherwise: Yup.date().notRequired(),
      // }),
      // rows: Yup.array().of(
      //   Yup.object({
      //     relation: Yup.string().required('Relation is required'),
      //     name: Yup.string().required('Name is required'),
      //     dob: Yup.date().required('Date of birth is required'),
      //   })
      // )
    }),
    onSubmit: (values) => {
      const formattedPayload = transformPayload(values, empID);

      const formData = new FormData();
      formData.append("lst_employee_family", JSON.stringify(formattedPayload));
      formData.append("create_by", authDetails?.user_id);
      formData.append("father_image", values.fatherPhoto);
      formData.append("mother_image", values.motherPhoto);
      formData.append("guardian_image", values.guardianPhoto);
      formData.append("spouse_image", values.spousePhoto);
      dispatch(createEmployee(formData, 'family'));
      // formik.resetForm();
    },
  });

  // const handlePhotoUpload = (event, fieldName, setFieldValue) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setPreviews((prev) => ({ ...prev, [fieldName]: reader.result })); // Update preview
  //     };
  //     reader.readAsDataURL(file);

  //     setFieldValue(fieldName, file); // Store file in Formik
  //   }
  // };

  const handlePhotoUpload = (event, fieldName, setFieldValue, setFieldError) => {
    const file = event.target.files[0];

    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png"];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // ✅ Type Validation
      if (!allowedTypes.includes(file.type)) {
        setFieldError(fieldName, "Only JPG, JPEG, and PNG formats are allowed.");
        return;
      }

      // ✅ Size Validation
      if (file.size > maxSize) {
        setFieldError(fieldName, "File size must not exceed 2MB.");
        return;
      }

      // ✅ If valid, update preview and Formik
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews((prev) => ({
          ...prev,
          [fieldName]: reader.result,
        }));
        setFieldValue(`${fieldName}Preview`, reader.result); // Optional: for Yup
      };
      reader.readAsDataURL(file);

      setFieldValue(fieldName, file);
    }
  };


  const handleReset = (fieldName, setFieldValue) => {
    setPreviews((prev) => ({ ...prev, [fieldName]: null }));
    setFieldValue(fieldName, null);
  };


  const handleAddRow = () => {
    setRows([...rows, { id: Date.now(), emp_id: empID, relation_id: "", child_name: "", child_dob: null, RelationType: "5" }]);
  };

  const handleRemoveRow = (id) => {
    setRows(rows.filter(row => row.id !== id));
  };

  const handleChange = (id, field, value) => {
    setRows(rows.map(row => (row.id === id ? { ...row, [field]: value } : row)));
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  useEffect(() => {
    if (empID && dropdownData && Object.keys(dropdownData).length > 0) {
      dispatch(fetchEmployeeTabWiseInfo(empID, 'family'));
    }
  }, [dispatch,empID, dropdownData]);

  const [inputKeys, setInputKeys] = useState({
    fatherPhoto: Date.now() + "_father",
    motherPhoto: Date.now() + "_mother",
    guardianPhoto: Date.now() + "_guardian",
    spousePhoto: Date.now() + "_spouse",
  });

  useEffect(() => {
    if (success) {
      // setPreviews({
      //   fatherPhoto: null,
      //   motherPhoto: null,
      //   guardianPhoto: null,
      //   spousePhoto: null,
      // });

      formik.setFieldValue("fatherPhoto", "");
      formik.setFieldValue("motherPhoto", "");
      formik.setFieldValue("guardianPhoto", "");
      formik.setFieldValue("spousePhoto", "");

      // 🔑 regenerate keys so inputs fully reset
      setInputKeys({
        fatherPhoto: Date.now() + "_father",
        motherPhoto: Date.now() + "_mother",
        guardianPhoto: Date.now() + "_guardian",
        spousePhoto: Date.now() + "_spouse",
      });

      if (onSuccess) {
        onSuccess();
      }
    }
  }, [success, onSuccess]);

  return (
    <div onSubmit={formik.handleSubmit}>

      <div className="family-details">
        <Row>
          <Col md={6}>
            <Card >
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title">Father</h4>
                </div>
              </div>
              <CardBody>
                <Row>
                  <Col className="col-12" >
                    <div className="d-flex gap-20 align-items-center image-upload">
                      <div className="d-flex justify-content-center align-items-center photo-div">
                        <img src={previews.fatherPhoto || ava1} alt="Father" />
                      </div>
                      <div>
                        <div className="upload-personal d-flex gap-2">
                          {/* <FormGroup className="">
                            <Input type="file" accept="image/*" onChange={(e) => handlePhotoUpload(e, "fatherPhoto", formik.setFieldValue)} />
                          </FormGroup> */}
                          <FormGroup>
                            <Input
                              key={inputKeys.fatherPhoto}
                              name="fatherPhoto"
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handlePhotoUpload(e, "fatherPhoto", formik.setFieldValue, formik.setFieldError)
                              }
                              onBlur={formik.handleBlur}
                              invalid={formik.touched.fatherPhoto && !!formik.errors.fatherPhoto}
                            />
                            {/* {formik.touched.fatherPhoto && formik.errors.fatherPhoto && (
                              <div className="text-danger">{formik.errors.fatherPhoto}</div>
                            )} */}
                          </FormGroup>
                          <Button type="reset" className="btn btn-light account-image-reset mb-3"
                            onClick={() => {
                              formik.setFieldValue("fatherPhoto", "");
                              setPreviews((prev) => ({ ...prev, fatherPhoto: "" })); // Clear preview
                            }}
                          >
                            Reset
                          </Button>
                        </div>
                        <p className="text-danger">
                          {formik.touched.fatherPhoto && formik.errors.fatherPhoto ? (
                            <div>{formik.errors.fatherPhoto}</div>
                          ) : (
                            <span className="text-muted">Allowed JPG, JPEG, or PNG. Max size of 2MB.</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className="col-12">
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="fatherFullName">Full Name <span className="text-danger">*</span></Label>
                          <Input
                            id="fatherFullName"
                            name="fatherFullName"
                            type="text"
                            maxLength={40}
                            value={formik.values.fatherFullName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.fatherFullName && !!formik.errors.fatherFullName}
                          />
                          {formik.touched.fatherFullName && formik.errors.fatherFullName && (
                            <div className="text-danger">{formik.errors.fatherFullName}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="fatherDOB">Date of Birth</Label>
                          {/* <Input
                            type="date"
                            id="fatherDOB"
                            name="fatherDOB"
                            value={
                              formik.values.fatherDOB
                                ? moment(formik.values.fatherDOB).format("YYYY-MM-DD") // Convert Date Object -> YYYY-MM-DD
                                : ""
                            }
                            onChange={(e) => formik.setFieldValue("fatherDOB", e.target.value)}
                            onBlur={formik.handleBlur}
                            className={`form-control ${formik.touched.fatherDOB && formik.errors.fatherDOB ? "is-invalid" : ""}`}
                          /> */}
                          <CustomDatePicker
                            name="fatherDOB"
                            value={formik.values.fatherDOB}
                            onChange={(date) => formik.setFieldValue("fatherDOB", date)}
                            onBlur={formik.handleBlur}
                            disableFuture={true}
                            className={`form-control ${formik.touched.fatherDOB && formik.errors.fatherDOB ? "is-invalid" : ""}`}
                          />
                          {formik.touched.fatherDOB && formik.errors.fatherDOB && (
                            <div className="text-danger">{formik.errors.fatherDOB}</div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            {/* Mother Section */}
            <Card className="mb-4">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title">Mother</h4>
                </div>
              </div>
              <CardBody>
                <Row>
                  <Col className="col-12" >
                    <div className="d-flex gap-20 align-items-cente image-upload">
                      <div className="d-flex justify-content-center align-items-center photo-div">
                        <img src={previews["motherPhoto"] || ava2} alt="Mother" />
                      </div>
                      <div>
                        <div className="upload-personal d-flex gap-2">
                          <FormGroup className="">
                            <Input type="file" accept="image/*" name="motherPhoto" key={inputKeys.motherPhoto}
                              // onChange={(e) => handlePhotoUpload(e, "motherPhoto", formik.setFieldValue)} 
                              onChange={(e) =>
                                handlePhotoUpload(e, "motherPhoto", formik.setFieldValue, formik.setFieldError)
                              }
                              onBlur={formik.handleBlur}
                              invalid={formik.touched.motherPhoto && !!formik.errors.motherPhoto}
                            />
                          </FormGroup>
                          <Button type="reset" className="btn btn-light account-image-reset mb-3"
                            onClick={() => {
                              formik.setFieldValue("motherPhoto", "");
                              setPreviews((prev) => ({ ...prev, motherPhoto: "" })); // Clear preview
                            }}
                          >
                            Reset
                          </Button>
                        </div>
                        <p className="text-danger">
                          {formik.touched.motherPhoto && formik.errors.motherPhoto ? (
                            <div>{formik.errors.motherPhoto}</div>
                          ) : (
                            <span className="text-muted">Allowed JPG, JPEG, or PNG. Max size of 2MB.</span>
                          )}
                        </p>
                      </div>
                    </div>

                  </Col>
                  <Col className="col-12" >
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="motherFullName">Full Name <span className="text-danger">*</span></Label>
                          <Input
                            id="motherFullName"
                            name="motherFullName"
                            type="text"
                            maxLength={40}
                            value={formik.values.motherFullName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.motherFullName && !!formik.errors.motherFullName}
                          />
                          {formik.touched.motherFullName && formik.errors.motherFullName && (
                            <div className="text-danger">{formik.errors.motherFullName}</div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="motherDOB">Date of Birth</Label>
                          {/* <Input
                            type="date"
                            id="motherDOB"
                            name="motherDOB"
                            // value={formik.values.motherDOB  || null}
                            value={
                              formik.values.motherDOB
                                ? moment(formik.values.motherDOB).format("YYYY-MM-DD") // Convert Date Object -> YYYY-MM-DD
                                : ""
                            }
                            onChange={(e) => formik.setFieldValue("motherDOB", e.target.value)}
                            onBlur={formik.handleBlur}
                            className={`form-control ${formik.touched.motherDOB && formik.errors.motherDOB ? "is-invalid" : ""}`}
                          /> */}
                          <CustomDatePicker
                            name="motherDOB"
                            value={formik.values.motherDOB}
                            onChange={(date) => formik.setFieldValue("motherDOB", date)}
                            onBlur={formik.handleBlur}
                            disableFuture={true}
                            className={`form-control ${formik.touched.motherDOB && formik.errors.motherDOB ? "is-invalid" : ""}`}
                          />
                          {formik.touched.motherDOB && formik.errors.motherDOB && (
                            <div className="text-danger">{formik.errors.motherDOB}</div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            {/* Guardian Section */}
            <Card className="mb-4">
              <div className="card-header">
                <div className="d-flex gap-2">
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        // id="isGuardian"
                        name="isGuardian"
                        checked={formik.values.isGuardian}
                        onChange={(e) => {
                          formik.setFieldValue("isGuardian", e.target.checked);
                          // handleCheckboxChange(e);
                        }}
                      />
                    </Label>
                  </FormGroup>
                  <h4 className="card-title">Guardian</h4>
                </div>
              </div>
              {formik.values.isGuardian && (
                <CardBody>
                  <Row>
                    <Col className="col-12">
                      <div className="d-flex gap-20 align-items-center image-upload">
                        <div className="d-flex justify-content-center align-items-center photo-div">
                          <img src={previews["guardianPhoto"] || ava3} alt="Guardian" />
                        </div>
                        <div>
                          <div className="upload-personal d-flex gap-2">
                            <FormGroup className="">
                              <Input type="file" accept="image/*" name="guardianPhoto" key={inputKeys.guardianPhoto}
                                // onChange={(e) => handlePhotoUpload(e, "guardianPhoto", formik.setFieldValue)} 
                                onChange={(e) =>
                                  handlePhotoUpload(e, "guardianPhoto", formik.setFieldValue, formik.setFieldError)
                                }
                                onBlur={formik.handleBlur}
                                invalid={formik.touched.guardianPhoto && !!formik.errors.guardianPhoto}
                              />
                            </FormGroup>
                            <Button type="reset" className="btn btn-light account-image-reset mb-3"
                              onClick={() => {
                                formik.setFieldValue("guardianPhoto", "");
                                setPreviews((prev) => ({ ...prev, guardianPhoto: "" })); // Clear preview
                              }}
                            >
                              Reset
                            </Button>
                          </div>
                          {/* <p className="">Allowed JPG, GIF or PNG. Max size of 800K</p> */}
                          <p className="text-danger">
                            {formik.touched.guardianPhoto && formik.errors.guardianPhoto ? (
                              <div>{formik.errors.guardianPhoto}</div>
                            ) : (
                              <span className="text-muted">Allowed JPG, JPEG, or PNG. Max size of 2MB.</span>
                            )}
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col className="col-12">
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="guardianFullName">Full Name <span className="text-danger">*</span></Label>
                            <Input
                              id="guardianFullName"
                              name="guardianFullName"
                              type="text"
                              maxLength={40}
                              value={formik.values.guardianFullName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={formik.touched.guardianFullName && !!formik.errors.guardianFullName}
                            />
                            {formik.touched.guardianFullName && formik.errors.guardianFullName && (
                              <div className="text-danger">{formik.errors.guardianFullName}</div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="guardianDOB">Date of Birth</Label>
                            {/* <Input
                            type="date"
                            id="guardianDOB"
                            name="guardianDOB"
                            // value={formik.values.guardianDOB  || null}
                            value={
                              formik.values.guardianDOB
                                ? moment(formik.values.guardianDOB).format("YYYY-MM-DD") // Convert Date Object -> YYYY-MM-DD
                                : ""
                            }
                            onChange={(e) => formik.setFieldValue("guardianDOB", e.target.value)}
                            onBlur={formik.handleBlur}
                            className={`form-control ${formik.touched.guardianDOB && formik.errors.guardianDOB ? "is-invalid" : ""}`}
                          /> */}
                            <CustomDatePicker
                              name="guardianDOB"
                              value={formik.values.guardianDOB}
                              onChange={(date) => formik.setFieldValue("guardianDOB", date)}
                              onBlur={formik.handleBlur}
                              disableFuture={true}
                              className={`form-control ${formik.touched.guardianDOB && formik.errors.guardianDOB ? "is-invalid" : ""}`}
                            />
                            {formik.touched.guardianDOB && formik.errors.guardianDOB && (
                              <div className="text-danger">{formik.errors.guardianDOB}</div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              )}
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title">Marital Status</h4>
                </div>
              </div>
              <CardBody>
                {formik.values.maritalStatus?.value === "2" && (
                  <>
                    <div className="d-flex gap-20 align-items-center image-upload">
                      <div className="d-flex justify-content-center align-items-center photo-div">
                        <img src={previews["spousePhoto"] || ava4} alt="Spouse" />
                      </div>
                      <div>
                        <div className="upload-personal d-flex gap-2">
                          <FormGroup className="">
                            <Input type="file" accept="image/*" name="spousePhoto" key={inputKeys.spousePhoto}
                              // onChange={(e) => handlePhotoUpload(e, "spousePhoto", formik.setFieldValue)}
                              onChange={(e) =>
                                handlePhotoUpload(e, "spousePhoto", formik.setFieldValue, formik.setFieldError)
                              }
                              onBlur={formik.handleBlur}
                              invalid={formik.touched.spousePhoto && !!formik.errors.spousePhoto}
                            />
                          </FormGroup>
                          <Button type="reset" className="btn btn-light account-image-reset mb-3"
                            onClick={() => {
                              formik.setFieldValue("spousePhoto", "");
                              setPreviews((prev) => ({ ...prev, spousePhoto: "" })); // Clear preview
                            }}
                          >
                            Reset
                          </Button>
                        </div>
                        {/* <p className="">Allowed JPG, GIF or PNG. Max size of 800K</p> */}
                        <p className="text-danger">
                          {formik.touched.spousePhoto && formik.errors.spousePhoto ? (
                            <div>{formik.errors.spousePhoto}</div>
                          ) : (
                            <span className="text-muted">Allowed JPG, JPEG, or PNG. Max size of 2MB.</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="maritalStatus">Marital Status <span className="text-danger">*</span></Label>
                      <Select
                        styles={SelectcustomStyles}
                        id="maritalStatus"
                        name="maritalStatus"
                        value={formik.values.maritalStatus || ""}
                        onChange={(selectedOption) => formik.setFieldValue('maritalStatus', selectedOption || null)} isClearable
                        options={maritalStatusOptions}
                        className="hrms-select"
                        classNamePrefix="hrms-select"
                      />
                      {formik.touched.maritalStatus && formik.errors.maritalStatus && (
                        <div className="text-danger">{formik.errors.maritalStatus}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {formik.values.maritalStatus?.value === "2" && (
                    <>
                      <Col md={6} className="mb-3">
                        <FormGroup>
                          <Label for="spouseName">Spouse Name</Label>
                          <Input
                            id="spouseName"
                            name="spouseName"
                            type="text"
                            maxLength={40}
                            value={formik.values.spouseName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.spouseName && formik.errors.spouseName}
                          />
                          {formik.touched.spouseName && formik.errors.spouseName && (
                            <div className="text-danger">{formik.errors.spouseName}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={6} className="mb-3">
                        <FormGroup>
                          <Label for="spouseDOB">Spouse Date of Birth (dd.mm.yyyy)</Label>
                          {/* <Input
                            type="date"
                            id="spouseDOB"
                            name="spouseDOB"
                            // value={formik.values.spouseDOB || null}
                            value={
                              formik.values.spouseDOB
                                ? moment(formik.values.spouseDOB).format("YYYY-MM-DD") // Convert Date Object -> YYYY-MM-DD
                                : ""
                            }
                            onChange={(e) => formik.setFieldValue("spouseDOB", e.target.value)}
                            onBlur={formik.handleBlur}
                            className={`form-control ${formik.touched.spouseDOB && formik.errors.spouseDOB ? "is-invalid" : ""}`}
                          /> */}
                          <CustomDatePicker
                            name="spouseDOB"
                            value={formik.values.spouseDOB}
                            onChange={(date) => formik.setFieldValue("spouseDOB", date)}
                            onBlur={formik.handleBlur}
                            disableFuture={true}
                            className={`form-control ${formik.touched.spouseDOB && formik.errors.spouseDOB ? "is-invalid" : ""}`}
                          />
                          {formik.touched.spouseDOB && formik.errors.spouseDOB && (
                            <div className="text-danger">{formik.errors.spouseDOB}</div>
                          )}
                        </FormGroup>
                      </Col>


                      <Col md={6} className="mb-3">
                        <FormGroup>
                          <Label for="weddingDate">Wedding Date (dd.mm.yyyy)</Label>
                          {/* <Input
                            type="date"
                            id="weddingDate"
                            name="weddingDate"
                            // value={formik.values.weddingDate || ""}
                            value={
                              formik.values.weddingDate
                                ? moment(formik.values.weddingDate).format("YYYY-MM-DD") // Convert Date Object -> YYYY-MM-DD
                                : ""
                            }
                            onChange={(e) => formik.setFieldValue("weddingDate", e.target.value)}
                            onBlur={formik.handleBlur}
                            className={`form-control ${formik.touched.weddingDate && formik.errors.weddingDate ? "is-invalid" : ""}`}
                          /> */}
                          <CustomDatePicker
                            name="weddingDate"
                            value={formik.values.weddingDate}
                            onChange={(date) => formik.setFieldValue("weddingDate", date)}
                            onBlur={formik.handleBlur}
                            disableFuture={true}
                            className={`form-control ${formik.touched.weddingDate && formik.errors.weddingDate ? "is-invalid" : ""}`}
                          />
                          {formik.touched.weddingDate && formik.errors.weddingDate && (
                            <div className="text-danger">{formik.errors.weddingDate}</div>
                          )}
                        </FormGroup>
                      </Col>


                    </>
                  )}
                </Row>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </div>
      <div className="family-details">
        <Card >
          <div className="card-header">
            <div className="d-flex justify-content-between">
              <h4 className="card-title">Relationship Details</h4>
            </div>
          </div>
          <CardBody>
            <Row>
              <Col md={12} className="mb-3">
                <div >
                  <Table bordered>
                    <thead>
                      <tr>
                        <th style={{ width: "50px", textAlign: "center", cursor: "pointer" }}>
                          <i className="mdi mdi-plus-circle font-size-18 text-primary" onClick={handleAddRow}></i>
                        </th>
                        <th>Relation</th>
                        <th>Name</th>
                        <th>DOB</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={row.id}>
                          <td style={{ textAlign: "center" }}>
                            {/* {index > 0 && ( */}
                            <i className="mdi mdi-close-circle font-size-18 text-danger" onClick={() => handleRemoveRow(row.id)}></i>
                            {/* )} */}
                          </td>
                          <td>
                            {/* <Input
                          type="select"
                          value={row.relation}
                          onChange={(e) => handleChange(row.id, "relation", e.target.value)}
                        >
                          <option value="">Select Relation</option>
                          <option value="Son">Son</option>
                          <option value="Daughter">Daughter</option>
                          <option value="Brother">Brother</option>
                          <option value="Sister">Sister</option>
                        </Input> */}
                            {/* <CustomSelect
                              styles={SelectcustomStyles}
                              id={`relation-${row.id}`}
                              name={`relation-${row.id}`}
                              options={(relation || [])
                                .filter((sal) => sal.r_type === "5") // ✅ Only load relations where r_type = "4"
                                .map((sal) => ({
                                  value: sal.relation_id,
                                  label: sal.relation_name,
                                }))
                              }
                              value={
                                row.relation_id
                                  ? relation.find((sal) => sal.relation_id === row.relation_id) // ✅ Ensure correct selection
                                    ? {
                                      value: row.relation_id,
                                      label: relation.find((sal) => String(sal.relation_id) === String(row.relation_id))?.relation_name
                                    }
                                    : null
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleChange(row.id, "relation_id", selectedOption? String(selectedOption.value) :"")
                              }
                            /> */}
                            {/* <CustomSelect
                              styles={SelectcustomStyles}
                              options={childRelationOptions}
                              value={
                                row.relation_id
                                  ? childRelationOptions.find(
                                    (opt) => String(opt.value) === String(row.relation_id)
                                  )
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleChange(
                                  row.id,
                                  "relation_id",
                                  selectedOption ? String(selectedOption.value) : ""
                                )
                              }
                            /> */}
                            <CustomSelect
                              styles={SelectcustomStyles}
                              options={childRelationOptions}
                              value={
                                row.relation_id
                                  ? childRelationOptions.find(
                                    (opt) => String(opt.value) === String(row.relation_id)
                                  )
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleChange(
                                  row.id,
                                  "relation_id",
                                  selectedOption ? String(selectedOption.value) : ""
                                )
                              }
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              value={row.child_name}
                              onChange={(e) => handleChange(row.id, "child_name", e.target.value)}
                              placeholder="Enter Name"
                            />
                          </td>
                          <td>
                            {/* <DatePicker
                              selected={row.child_dob}
                              onChange={(date) => handleChange(row.id, "child_dob", date)}
                              dateFormat="yyyy-MM-dd"
                              className="form-control"
                              placeholderText="YYYY-MM-DD"
                            /> */}
                            <CustomDatePicker
                              name={`child_dob-${index}`}
                              value={row.child_dob}
                              onChange={(date) => handleChange(row.id, "child_dob", date)}
                              disableFuture={true}
                              onBlur={formik.handleBlur}
                            // className={`form-control ${formik.touched.weddingDate && formik.errors.weddingDate ? "is-invalid" : ""}`}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col className="d-flex justify-content-end align-items-center">
                {/* <button type="submit" className="btn button-save d-flex align-items-center gap-2">
                  <i className="fas fa-save " /> Save & Continue
                </button> */}
                <button
                  type="button"
                  className="btn button-save d-flex align-items-center gap-2"
                  onClick={formik.handleSubmit}
                >
                  <i className="fas fa-save" /> Save & Continue
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div >
  );
};

export default EmployeeFamily;
